import React, { Component } from 'react'
import TileFilter from './TileFilter'
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom'

const FakeComp = props => {
  return <div>I'm a fake prop</div>
}

export default class PaginatedTileFilter extends Component {
  render() {
    return (
      <Router basename={this.props.base}>
        <div>
          <Switch>
            <Route
              path="/:category/:page"
              render={routeProps => {
                return (
                  <TileFilter
                    {...this.props.innerProps}
                    {...routeProps}
                    useRouter={true}
                  />
                )
              }}
            />
            <Route
              path="/:page?"
              render={routeProps => {
                return (
                  <TileFilter
                    {...this.props.innerProps}
                    {...routeProps}
                    useRouter={true}
                  />
                )
              }}
            />
          </Switch>
        </div>
      </Router>
    )
  }
}
